
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionReleaseType,
    CollectionReleasePayloadType,
} from "@/common/types/collection-release";

export async function collectionReleaseList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/release/list${queryString}`
    );
}

export async function collectionReleaseGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/release/${item_id}/show`
    );
}

export async function collectionReleaseCreate(
    collection_id: string,
    payload: CollectionReleasePayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/release/create`,
        payload
    );
}

export async function collectionReleasePatch(
    item_id: string,
    payload: Partial<CollectionReleaseType>
) {
    return await clientAxios.patch(
        `collection/release/${item_id}/patch`,
        { payload }
    );
}

export async function collectionReleaseDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/release/${item_id}/delete`,
    );
}
